import React from 'react'
import styles from './Style.module.css'
import { BtnPrimary } from '../Buttons/BtnPrimary'
import { Link } from 'react-router-dom'

export const Footer = ({
  btnLabel,
  btnClick,
  isFooterActive,
  disabled,
  customClass,
  customClassForTerms,
  noTerms = false,
  nativeDisabled = false,
  footerRef,
}) => {
  return (
    <div ref={footerRef} data-snackbar-footer={!!isFooterActive} className={`${styles.footer} ${isFooterActive ? styles.active : ""} space-x ${customClass}`}>
        <BtnPrimary
            label={btnLabel}
            handleClick={btnClick}
            disabled={disabled}
            nativeDisabled={nativeDisabled}
        />
        {!noTerms && (
        <div className={customClassForTerms}>
        <p>By continuing, you agree to our </p>
        <p><Link
            className="underline"
            to="https://www.natureland.com.sg/terms-and-conditions/"
            target="_blank"
            title="Terms and Conditions"
          > Terms & Conditions </Link> and <Link
            className="underline"
            to="https://www.natureland.com.sg/pdpc-policy/"
            target="_blank"
            title="PDPC Policy"
          > Privacy Policy* </Link>
          </p>
        </div>
        )}
    </div>
  )
}
